'use es6';

import PropTypes from 'prop-types';
import ContentViewport from '../../../components/ContentViewport';
import { RequiredProductNames } from '../../../constants/CourseConstants';
import ContentControlWrapper from '../../../components/ContentControlWrapper';
import UIButton from 'UIComponents/button/UIButton';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { H1 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PRODUCT_TO_ICON_MAP = {
  [RequiredProductNames.crm]: 'crm',
  [RequiredProductNames.marketing]: 'marketing-free',
  [RequiredProductNames.sales]: 'sales-free'
};
const BASE_CLASS_NAME = 'practical-exercise-required-product';
const PracticalExerciseRequiredAccess = ({
  advanceToNextContent,
  product
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsxs(ContentViewport, {
    wrapperClassName: BASE_CLASS_NAME,
    children: [/*#__PURE__*/_jsx(H1, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.practicalExercise.requiredAccess.${product}.header`
      })
    }), /*#__PURE__*/_jsx(UIIllustration, {
      name: PRODUCT_TO_ICON_MAP[product]
    }), /*#__PURE__*/_jsx("p", {
      className: `${BASE_CLASS_NAME}__description`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.practicalExercise.requiredAccess.${product}.description`
      })
    })]
  }), /*#__PURE__*/_jsx(ContentControlWrapper, {
    children: /*#__PURE__*/_jsx("div", {
      className: `${BASE_CLASS_NAME}__content-control`,
      children: /*#__PURE__*/_jsx(UIButton, {
        className: `${BASE_CLASS_NAME}__skip-button`,
        "data-test-id": "skip-nonstarted-practical-exercise",
        onClick: advanceToNextContent,
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.practicalExercise.skip`
        })
      })
    })
  })]
});
PracticalExerciseRequiredAccess.propTypes = {
  advanceToNextContent: PropTypes.func.isRequired,
  product: PropTypes.oneOf(Object.keys(RequiredProductNames)).isRequired
};
export default PracticalExerciseRequiredAccess;